import React from 'react';
import { createRoot } from 'react-dom/client';
import { App }  from './App';
import * as serviceWorker from './serviceWorker';
import { store } from './_helpers';
import { Provider } from 'react-redux';


// import "./styles/css/main.css";


createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
